@if (message()) {
  <output class="month-unlock">
    <mat-icon class="month-unlock__icon" aria-hidden="true">lock_open</mat-icon>
    <span class="month-unlock__text">{{ message() }}</span>
    <button type="button" class="month-unlock__relock" (click)="relock()">{{ relockLabel() }}</button>
  </output>
}
